<template>
  <v-container grid-list-md page>
    <v-flex>
      <h1 class="title primary--text my-3">検索結果：{{searchResultCount}}曲HITしました</h1>
      <p>シーン：{{sceneNames}}</p>
      <p>タグ：{{tagNames}}</p>
      <p>フリーワード：{{freeWords}}</p>
      <p v-show="checkPlaylistFlg">プレイリストに登録済の曲は表示しない</p>
      <v-list two-line :class=shufflePlay>
        <v-list-tile v-for="(item, index) in items" :key="item.product_id" avatar class="itemDivider" :class="nowPlayingIndex">
          <play-btn
            :itemTitle="item.name"
            :itemArtist="item.artist_name"
            :itemSrc="item.mp3"
            :itemIndex=parseInt(index)
            :itemProductId="item.product_id"
            :resultsCount="item.results_count"
            :musicPlayerType=musicPlayerType
          />
          <v-list-tile-content>
            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            <router-link :to="'/home/artist/detail/' + item.artist_id">
              <v-list-tile-sub-title>{{ item.artist_name }}</v-list-tile-sub-title>
            </router-link>
          </v-list-tile-content>
          <v-spacer></v-spacer>
          <lyrics
            :title="item.name"
            :artist="item.artist_name"
            :lyrics="item.lyrics"
            :introduction="item.introduction"
          />
          <more-btn
          :addIsumBtn="false"
          :addCommentBtn="false"
          :addMusicBtn="false"
          :addListBtn="true"
          :addFavoriteBtn="true"
          :deleteListBtn="false"
          :productId="item.product_id"
        />
        </v-list-tile>
        <infinite-loading @infinite="infiniteHandler" ref="infiniteLoading" ></infinite-loading>
      </v-list>
    </v-flex>
  </v-container>
</template>

<script>
import Lyrics from '@/components/Lyrics.vue'
import MoreBtn from '@/components/MoreBtn.vue'
import PlayBtn from '@/components/PlayBtn.vue'
import InfiniteLoading from 'vue-infinite-loading'
import PlayListService from '@/components/services/PlayListService.vue'
import SceneService from '@/components/services/SceneService.vue'
import TagService from '@/components/services/TagService.vue'
export default {
  name: 'Search',
  components: {
    InfiniteLoading,
    Lyrics,
    MoreBtn,
    PlayBtn
  },
  data () {
    return {
      items: [],
      sceneNames: '',
      tagNames: '',
      freeWords: '',
      checkPlaylistFlg: false,
      searchResultCount: '',
      musicPlayerType: 'search'
    }
  },
  props: {
    source: String
  },
  created () {
    this.items = this.$store.state.searchResult
  },
  mounted () {
    this.sceneNames = this.showSearchConditionScene(this.$store.state.selectedsceneIdArray)
    this.tagNames = this.showSearchConditionTag(this.$store.state.selectedTagIdArray)
    this.freeWords = this.$store.state.freeWords
    this.checkPlaylistFlg = this.$store.state.checkPlaylistFlg
    this.searchResultCount = this.$store.state.searchResultCount
  },
  destroyed () {
    this.$store.commit('musicPlayerModuleUpdateDisableBtnPrev', false)
    this.$store.commit('searchInfiniteLoadingFlg', false)
  },
  computed: {
    isPlaying () {
      return this.$store.getters.musicPlayerModuleGetIsPlaying
    },
    shufflePlay () {
      let isShufflePlay = this.$store.getters.musicPlayerModuleGetIsShufflePlay
      this.changeShufflePlay(isShufflePlay)
      return isShufflePlay
    },
    nowPlayingIndex () {
      let nowIndex = Number(this.$store.getters['musicPlayerModuleGetNowPlayTuneData'].index)
      let resultCount = Number(this.$store.state.searchResultCount)
      let itemCount = Number(this.items.length)

      if ((resultCount > itemCount + 1)) {
        if ((nowIndex > (itemCount - 2)) && !this.$store.getters['getSearchInfiniteLoadingFlg']) {
          // 1曲前を超えたら次のリストの読み込みイベントを自動発火
          this.infiniteHandler()
        }
      }

      return nowIndex
    }
  },
  methods: {
    infiniteHandler ($state = { loaded () {}, complete () {} }) {
      this.$store.commit('searchInfiniteLoadingFlg', true)
      setTimeout(() => {
        let offset = this.$store.state.searchOffset + this.$store.state.perSearchCount
        let formData = new URLSearchParams()
        // シーンをパラメータに
        for (var scene in this.$store.state.selectedsceneIdArray) {
          formData.append('scene[]', this.$store.state.selectedsceneIdArray[scene])
        }
        // タグをパラメータに
        for (var tag in this.$store.state.selectedTagIdArray) {
          formData.append('tag[]', this.$store.state.selectedTagIdArray[tag])
        }
        // フリーワードをパラメータに
        if (this.$store.state.freeWords !== undefined) {
          let freewordArray = []
          freewordArray = this.$store.state.freeWords.replace(/\s+/g, ' ').split(' ')
          for (let i in freewordArray) {
            let word = freewordArray[i]
            formData.append('freeword[]', word)
          }
        }
        // プレイリスト・チェックボックス
        formData.append('playlist', this.$store.state.checkPlaylistFlg)

        formData.append('offset', offset)
        // FIXME 検索結果件数を変更してください
        formData.append('limit', this.$store.state.perSearchCount)
        formData.append('transactionid', this.$store.state.transactionId)
        PlayListService.searchTrue(formData, (response) => {
          var responseCount = (Object.keys(response).length)
          if (responseCount > 0) {
            var newItems = []
            for (var index in this.items) {
              newItems.push(this.items[index])
            }
            for (var index2 in response) {
              newItems.push(response[index2])
            }
            this.items = newItems
            // ↑ 既に表示されていた曲リスト + 新たに追加された曲（通常の曲順）

            this.$store.commit('updateSearchResult', newItems)
            this.$store.commit('updateStateSearchOffset', offset)

            if (this.$store.getters['musicPlayerModuleGetNowPlayListType'] === 'search' || this.$store.getters['musicPlayerModuleGetNowPlayListType'] === 'searchShufflePlay') {
              // 検索結果を再設定（再生範囲修正のために追加）* SearchTuneModal.vueにも同様の記述追加
              this.$store.commit('musicPlayerModuleStartPlayList', [this.nowPlayingIndex, 'search'])
              let shufflePlayListTmp = this.$store.getters.musicPlayerModuleGetShufflePlayList
              let shufflePlayList = this.$store.getters.musicPlayerModuleGetNowSelectedPlayList.slice(offset)
              // offsetまで連番でセットして、offset以降をランダム再生
              let target = shufflePlayList.map(record => { return record })
              let a = target.length
              while (a) {
                let j = Math.floor(Math.random() * a)
                let t = target[--a]
                target[a] = target[j]
                target[j] = t
              }
              target = shufflePlayListTmp.concat(target)
              this.$store.commit('musicPlayerModuleUpdateShufflePlayList', target)
              this.$store.commit('musicPlayerModuleShuffle', this.$store.getters.musicPlayerModuleGetIsShufflePlay)

              if (this.$store.getters.musicPlayerModuleGetIsShufflePlay) {
                this.musicPlayerType = 'searchShufflePlay'
                this.$store.commit('musicPlayerModuleStartPlayList', [this.nowPlayingIndex, 'searchShufflePlay'])
              }
            }
            $state.loaded()
          } else {
            $state.complete()
          }
          this.$store.commit('searchInfiniteLoadingFlg', false)
        })
      }, 1000)
    },
    showSearchConditionScene (sceneIdArray) {
      let index = 0
      let sceneNames = ''
      if (sceneIdArray.length > 0) {
        sceneIdArray.forEach(id => {
          if (index === 0) {
            sceneNames = SceneService.findSceneNameBySceneId(id)
          } else {
            sceneNames += '、' + SceneService.findSceneNameBySceneId(id)
          }
          index++
        })
      } else {
        sceneNames = '-'
      }
      return sceneNames
    },
    showSearchConditionTag (TagIdArray) {
      let index = 0
      let tagNames = ''
      if (TagIdArray.length > 0) {
        TagIdArray.forEach(id => {
          if (index === 0) {
            tagNames = TagService.findTagNameByTagId(id)
          } else {
            tagNames += '、' + TagService.findTagNameByTagId(id)
          }
          index++
        })
      } else {
        tagNames = '-'
      }
      return tagNames
    },
    changeShufflePlay (isShufflePlay) {
      if (this.$store.getters.musicPlayerModuleGetIsPlaying === false) {
        if (isShufflePlay === true) {
          this.musicPlayerType = 'searchShufflePlay'
        } else {
          this.musicPlayerType = 'search'
        }
        this.$store.commit('musicPlayerModuleSetPlayList', this.musicPlayerType)
      } else {
        this.musicPlayerType = 'search'
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/home/Search.vue